import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function AboutPage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useState(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  });

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#202835] shadow-lg' : 'bg-[#202835]'}`}>
        <div className="container mx-auto px-6">
          <div className="flex items-center justify-between h-24">
            <Link className="flex items-center" to="/">
              <img 
                alt="شركة الهمة الذهبية" 
                className="h-16 w-auto" 
                src="https://static.readdy.ai/image/8f4b99b6f50522f57c0c4089909ec764/c39a188db929712e2f2919bb54dee404.png"
              />
            </Link>

            <nav className="hidden lg:flex items-center gap-8">
              <Link className="relative text-white font-semibold transition-all duration-300 hover:text-[#d4af37] group" to="/">
                الرئيسية
                <span className="absolute bottom-0 right-0 w-0 h-0.5 bg-[#d4af37] transition-all duration-300 group-hover:w-full"></span>
              </Link>
              <Link className="relative text-white font-semibold transition-all duration-300 hover:text-[#d4af37] group text-[#d4af37]" to="/about">
                من نحن
                <span className="absolute bottom-0 right-0 w-full h-0.5 bg-[#d4af37]"></span>
              </Link>
              <Link className="relative text-white font-semibold transition-all duration-300 hover:text-[#d4af37] group" to="/services">
                الخدمات
                <span className="absolute bottom-0 right-0 w-0 h-0.5 bg-[#d4af37] transition-all duration-300 group-hover:w-full"></span>
              </Link>
              <Link className="relative text-white font-semibold transition-all duration-300 hover:text-[#d4af37] group" to="/projects">
                المشاريع
                <span className="absolute bottom-0 right-0 w-0 h-0.5 bg-[#d4af37] transition-all duration-300 group-hover:w-full"></span>
              </Link>
              <Link className="relative text-white font-semibold transition-all duration-300 hover:text-[#d4af37] group" to="/news">
                الأخبار
                <span className="absolute bottom-0 right-0 w-0 h-0.5 bg-[#d4af37] transition-all duration-300 group-hover:w-full"></span>
              </Link>
            </nav>

            <Link className="hidden lg:block px-8 py-3 bg-[#d4af37] text-white font-bold rounded-full hover:bg-[#c19b2e] transition-all duration-300 hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer" to="/contact">
              تواصل معنا
            </Link>

            <button 
              className="lg:hidden text-white text-2xl w-10 h-10 flex items-center justify-center cursor-pointer"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              <i className={isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}></i>
            </button>
          </div>
        </div>

        {isMobileMenuOpen && (
          <div className="lg:hidden bg-[#202835] border-t border-white/10">
            <nav className="container mx-auto px-6 py-4 flex flex-col gap-4">
              <Link className="text-white font-semibold hover:text-[#d4af37] transition-colors" to="/">الرئيسية</Link>
              <Link className="text-white font-semibold hover:text-[#d4af37] transition-colors" to="/about">من نحن</Link>
              <Link className="text-white font-semibold hover:text-[#d4af37] transition-colors" to="/services">الخدمات</Link>
              <Link className="text-white font-semibold hover:text-[#d4af37] transition-colors" to="/projects">المشاريع</Link>
              <Link className="text-white font-semibold hover:text-[#d4af37] transition-colors" to="/news">الأخبار</Link>
              <Link className="text-white font-semibold hover:text-[#d4af37] transition-colors" to="/contact">تواصل معنا</Link>
            </nav>
          </div>
        )}
      </header>

      {/* Hero Section */}
      <section className="relative h-[60vh] w-full overflow-hidden mt-24">
        <div className="absolute inset-0 w-full h-full">
          <img 
            alt="من نحن - شركة الهمة الذهبية" 
            className="w-full h-full object-cover object-center" 
            src="https://public.readdy.ai/ai/img_res/30ddf98dd21ff748b0e7c41434450c41.jpg"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#202835]/80 via-[#202835]/70 to-[#202835]/80"></div>
        </div>
        <div className="relative z-10 h-full flex items-center justify-center">
          <div className="container mx-auto px-6 text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-4">من نحن</h1>
            <div className="w-20 h-1 bg-[#d4af37] mx-auto mb-6"></div>
            <p className="text-xl text-white/90 max-w-3xl mx-auto">
              شركة الهمة الذهبية - رائدة في مجال الإنشاءات والمقاولات
            </p>
          </div>
        </div>
      </section>

      {/* About Content */}
      <section className="py-32 bg-white">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-24">
            <div>
              <div className="w-20 h-1 bg-[#d4af37] mb-6"></div>
              <h2 className="text-4xl md:text-5xl font-bold text-[#202835] mb-6">شركة الهمة الذهبية</h2>
              <h3 className="text-2xl font-semibold text-[#d4af37] mb-8">الريادة في الإنشاءات والمقاولات</h3>
              <div className="space-y-6 text-lg text-[#202835]/80 leading-relaxed">
                <p>
                  شركة الهمة الذهبية هي شركة رائدة تعمل في مجال الإنشاءات العامة للمقاولات، حيث تقدم الشركة للعميل خدمات متكاملة تشمل التشييد والبناء والترميم وتمديد الأنابيب بمختلف أنواعها وتمديد الأسلاك الكهربائية وأسلاك الاتصالات.
                </p>
                <p>
                  نقدم خدمات التركيب والصيانة للخدمات الثقيلة وتشمل الأعمال الميكانيكية، الأعمال الكهربائية، أعمال التيار الخفيف، والأعمال المدنية. كما تعمل الشركة على خدمات النظافة للمرافق والمناظر الطبيعية.
                </p>
                <p>
                  مع فريق من الخبراء والمتخصصين، نسعى لتحقيق رؤيتنا في أن نكون الخيار الأول للمستثمرين والباحثين عن التميز في قطاع المقاولات والإنشاءات.
                </p>
              </div>
            </div>
            <div className="relative w-full h-[500px]">
              <img 
                alt="شركة الهمة الذهبية" 
                className="w-full h-full object-cover object-center rounded-2xl shadow-2xl" 
                src="https://readdy.ai/api/search-image?query=Professional%20construction%20team%20reviewing%20architectural%20blueprints%20at%20modern%20building%20site%2C%20engineers%20and%20contractors%20in%20safety%20helmets%20examining%20plans%2C%20high-quality%20construction%20project%20management%20scene%20with%20steel%20structures%20in%20background%2C%20corporate%20photography%20style%20with%20natural%20lighting&width=800&height=1000&seq=about-team-construction-002&orientation=portrait"
              />
            </div>
          </div>

          {/* Vision & Mission */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-24">
            <div className="bg-[#faf8f3] rounded-2xl p-10">
              <div className="w-16 h-16 bg-[#d4af37]/20 rounded-full flex items-center justify-center mb-6">
                <i className="ri-eye-line text-3xl text-[#d4af37]"></i>
              </div>
              <h3 className="text-3xl font-bold mb-6 text-[#202835]">رؤيتنا</h3>
              <div className="space-y-4 text-[#202835]/80 leading-relaxed">
                <p>
                  نسعى لأن نكون رواد في مجال الترميم والتشغيل والصيانة في المملكة العربية السعودية وتقديم أعلى معايير الجودة والابتكار، لنضفي حياة جديدة على كل ما نعمل عليه، ونعزز الاستدامة والتفوق في كل مشروع والمساهمة في تحقيق رؤية المملكة 2030.
                </p>
                <p>
                  نحن في شركتنا نؤمن بقوة التحول، ونسعى دائمًا لإعادة الحياة إلى المنشآت من خلال خبراتنا المتميزة في الترميم والصيانة، لنقدم بيئات عمل ملهمة ومستدامة.
                </p>
              </div>
            </div>

            <div className="bg-[#faf8f3] rounded-2xl p-10">
              <div className="w-16 h-16 bg-[#d4af37]/20 rounded-full flex items-center justify-center mb-6">
                <i className="ri-compass-3-line text-3xl text-[#d4af37]"></i>
              </div>
              <h3 className="text-3xl font-bold mb-6 text-[#202835]">مهمتنا</h3>
              <div className="space-y-4 leading-relaxed text-[#202835]/80">
                <p>
                  تتمثل مهمتنا في تقديم خدمات ترميم وتشغيل وصيانة متكاملة، تساهم في تعزيز الاستدامة وتحسين الأداء التشغيلي للمرافق، مع توفير حلول موثوقة وفعالة تتسم بالكفاءة والجودة.
                </p>
                <p>
                  نحن نلتزم بتقديم خدمات ترميم وتشغيل وصيانة عالية الجودة تهدف إلى الحفاظ على سلامة وكفاءة المنشآت والمرافق، مع التركيز على الابتكار والالتزام بالمواعيد.
                </p>
              </div>
            </div>
          </div>

          {/* Values */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-[#202835] mb-4">قيمنا</h2>
            <div className="w-20 h-1 bg-[#d4af37] mx-auto"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-[#faf8f3] rounded-xl p-10 text-center group hover:shadow-xl transition-all duration-300 cursor-pointer">
              <div className="w-16 h-16 mx-auto mb-6 bg-[#d4af37]/20 rounded-full flex items-center justify-center">
                <i className="ri-medal-line text-4xl text-[#d4af37]"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#202835] mb-4">الجودة والتميز</h3>
              <p className="text-[#202835]/70 leading-relaxed">
                نلتزم بتقديم خدمات عالية الجودة في جميع جوانب الترميم والتشغيل والصيانة
              </p>
            </div>

            <div className="bg-[#faf8f3] rounded-xl p-10 text-center group hover:shadow-xl transition-all duration-300 cursor-pointer">
              <div className="w-16 h-16 mx-auto mb-6 bg-[#d4af37]/20 rounded-full flex items-center justify-center">
                <i className="ri-lightbulb-line text-4xl text-[#d4af37]"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#202835] mb-4">الابتكار والتطوير</h3>
              <p className="text-[#202835]/70 leading-relaxed">
                نؤمن بقوة الابتكار ونعمل باستمرار على تحسين تقنياتنا وأساليبنا
              </p>
            </div>

            <div className="bg-[#faf8f3] rounded-xl p-10 text-center group hover:shadow-xl transition-all duration-300 cursor-pointer">
              <div className="w-16 h-16 mx-auto mb-6 bg-[#d4af37]/20 rounded-full flex items-center justify-center">
                <i className="ri-leaf-line text-4xl text-[#d4af37]"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#202835] mb-4">الاستدامة</h3>
              <p className="text-[#202835]/70 leading-relaxed">
                نسعى لضمان استدامة المنشآت من خلال توفير حلول صيانة صديقة للبيئة
              </p>
            </div>

            <div className="bg-[#faf8f3] rounded-xl p-10 text-center group hover:shadow-xl transition-all duration-300 cursor-pointer">
              <div className="w-16 h-16 mx-auto mb-6 bg-[#d4af37]/20 rounded-full flex items-center justify-center">
                <i className="ri-shield-check-line text-4xl text-[#d4af37]"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#202835] mb-4">السلامة والأمان</h3>
              <p className="text-[#202835]/70 leading-relaxed">
                سلامة العمل وأمان الموظفين والعملاء هي أولويتنا القصوى
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="relative bg-[#202835] text-white overflow-hidden">
        <div className="container mx-auto px-6 relative z-10">
          <div className="py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
            <div>
              <Link className="inline-block mb-6" to="/">
                <img 
                  alt="شركة الهمة الذهبية" 
                  className="h-16 w-auto" 
                  src="https://static.readdy.ai/image/8f4b99b6f50522f57c0c4089909ec764/c39a188db929712e2f2919bb54dee404.png"
                />
              </Link>
              <p className="text-white/80 leading-relaxed mb-6">
                شركة الهمة الذهبية، شريكك الموثوق في عالم المقاولات والإنشاءات.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-bold text-[#d4af37] mb-6">روابط سريعة</h3>
              <ul className="space-y-3">
                <li><Link className="text-white/80 hover:text-[#d4af37] transition-colors" to="/about">من نحن</Link></li>
                <li><Link className="text-white/80 hover:text-[#d4af37] transition-colors" to="/services">الخدمات</Link></li>
                <li><Link className="text-white/80 hover:text-[#d4af37] transition-colors" to="/projects">المشاريع</Link></li>
                <li><Link className="text-white/80 hover:text-[#d4af37] transition-colors" to="/news">الأخبار</Link></li>
              </ul>
            </div>

            <div>
              <h3 className="text-xl font-bold text-[#d4af37] mb-6">خدماتنا</h3>
              <ul className="space-y-3">
                <li className="text-white/80">الإنشاءات والبناء</li>
                <li className="text-white/80">الترميم والصيانة</li>
                <li className="text-white/80">الأعمال الكهربائية</li>
                <li className="text-white/80">أنظمة السلامة</li>
              </ul>
            </div>

            <div>
              <h3 className="text-xl font-bold text-[#d4af37] mb-6">تواصل معنا</h3>
              <ul className="space-y-4">
                <li className="flex items-start gap-3 text-white/80">
                  <i className="ri-phone-line text-[#d4af37] text-xl mt-1"></i>
                  <div>
                    <div dir="ltr">+966 50 016 5920</div>
                    <div dir="ltr">+966 50 125 5250</div>
                  </div>
                </li>
                <li className="flex items-start gap-3 text-white/80">
                  <i className="ri-mail-line text-[#d4af37] text-xl mt-1"></i>
                  <span>info@gmcc.com.sa</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-white/10 py-6">
            <p className="text-white/60 text-sm text-center">
              © 2024 شركة الهمة الذهبية. جميع الحقوق محفوظة.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
